<ion-app [class]="environmentSlug">
  <ion-menu
    *ngIf="isMobile"
    contentId="main"
    persistent="true"
    autoHide="true"
    swipeGesture="false"
  >
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="full" class="mobile-menu">
        <ion-item>
          <a (click)="linkToPage({ path: '/' })">Home</a>
        </ion-item>
        <ion-item *ngFor="let item of headerMenu">
          <ng-container *ngIf="item.children; else topLevelItem">
            <ion-label position="stacked">{{ item.title }}</ion-label>

            <ion-list lines="none">
              <ion-item *ngFor="let child of item.children">
                <a
                  (click)="linkToPage(child)"
                  [attr.target]="child.newWindow ? '_blank' : '_self'"
                  >{{ child.title }}</a
                >
              </ion-item>
            </ion-list>
          </ng-container>

          <ng-template #topLevelItem>
            <a
              (click)="linkToPage(item)"
              [attr.target]="item.newWindow ? '_blank' : '_self'"
              >{{ item.title }}</a
            >
          </ng-template>
        </ion-item>

        <ion-item *ngIf="!user; else loggedInUser">
          <a (click)="linkToPage({ path: '/auth/login' })"> Login </a>
        </ion-item>

        <ng-template #loggedInUser>
          <ion-item *ngFor="let child of profileLinks">
            <a (click)="linkToPage(child)">{{ child.title }}</a>
          </ion-item>
        </ng-template>
      </ion-list>
    </ion-content>
  </ion-menu>

  <!-- Loading Overlay -->
  <div
    class="loading-overlay"
    [ngClass]="showLoadingOverlay ? 'visible' : 'hidden'"
  ></div>

  <div [className]="keyboardState">
    <ion-router-outlet id="main"></ion-router-outlet>
  </div>
</ion-app>
